import React, { useState, useEffect, useCallback } from "react";

import { format, addDays, addMonths, isSameMonth } from "date-fns";

import axios from "@app/lib/axios";

import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";
import CommonVerticalBarChart from "@app/components/CommonVerticalBarChart";

import flyengStyle from "../../components/style";

import MainContent from "./MainContent";

const appConnectChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: flyengStyle.seriesHomeAppConnectChart,
    },
    // stacks: [{ stack: "base", showPercent: false, showSum: true, showSumTooltip: false }],
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    showSum: false,
    sort: false,
    grid: {
        top: "15%",
        left: "10%",
        bottom: "10%",
    },
};
const branchChartOption = {
    xAxis: {
        name: "건",
        series: flyengStyle.seriesHomePlayChart2022,
    },
    yAxis: { field: "name" },
    showLegend: false,
    legend: {
        x: "right",
        y: "top",
    },
    showSum: false,
    sort: false,
    grid: {
        top: "5%",
        left: "20%",
        bottom: "10%",
    },
};
const nurseryChartOption = {
    xAxis: {
        name: "건",
        series: flyengStyle.seriesHomePlaySumChart2022,
    },
    yAxis: {
        field: "name",
        inverse: false,
    },
    showLegend: false,
    legend: {
        x: "right",
        y: "top",
    },
    showSum: true,
    sort: false,
    grid: {
        top: "5%",
        left: "20%",
        bottom: "10%",
    },
};
const HomeMain = ({ branchList, libCategories, statPeriod, handlerSelectStat, stat, updateMainStat }) => {
    const [statApp, setStatApp] = useState(false);
    const [statBranch, setStatBranch] = useState(false);
    const [statNursery, setStatNursery] = useState(false);
    const [statContent, setStatContent] = useState(false);

    const initStat = () => {
        setStatApp(false);
        setStatBranch(false);
        setStatNursery(false);
        setStatContent(false);
    };

    const getStat = () => {
        if(stat) {
            applyData(stat);
            return;
        }
        initStat();
        axios({
            method: "POST",
            url: `/api/flyeng_stat_2022/home/main`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                periodType: statPeriod.type,
                limit: 5,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    updateMainStat(result.data.data);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const applyData = (stat) => {
        let statApp = [];
        let statBranch = [];
        let statNursery = [];
        let statContent = [];

        let start = new Date(statPeriod.startDate);
        let day = new Date(statPeriod.startDate);
        for (let i = 0; i < 99; i++) {
            const statDate = format(day, statPeriod.type === "year" ? "yyyy-MM" : "yyyy-MM-dd");
            const statDateStr = format(day, statPeriod.type === "year" ? "yyyy-MM" : "MM-dd");
            const sApp = stat.app.find((s) => s.statDate === statDate);
            statApp.push({ ...sApp, statDate: statDateStr });
            if (statPeriod.type === "week") {
                day = addDays(day, 1);
                if (i >= 6) break;
            } else if (statPeriod.type === "month") {
                day = addDays(day, 1);
                if (!isSameMonth(day, start)) break;
            } else {
                // year
                day = addMonths(day, 1);
                if (i > 11) break;
            }
        }

        if (stat.branch && stat.branch.length > 0) {
            stat.branch.forEach((sb) => {
                const branch = branchList.find((b) => b.id === sb.branchId);
                if (branch) {
                    sb.name = branch.name;
                }
            });
            statBranch = stat.branch;
        }

        if (stat.nursery && stat.nursery.nurseries.length > 0) {
            statNursery = stat.nursery.nurseries;
            // sort
            statNursery.sort((a, b) => a.playCountSum - b.playCountSum);
        }

        if (stat.content && stat.content.length > 0) {
            statContent = stat.content;
        }

        setStatApp(statApp);
        setStatBranch(statBranch);
        setStatNursery(statNursery);
        setStatContent(statContent);
    };

    useEffect(() => {
        if (branchList && branchList.length > 0 && statPeriod) {
            getStat();
        }
        return () => {};
    }, [statPeriod, branchList]);

    useEffect(() => {
        if (stat) {
            applyData(stat);
        }
        return () => {};
    }, [stat]);

    const onSelectStat = (type) => {
        if (handlerSelectStat) {
            handlerSelectStat(type);
        } else {
            console.debug(type);
        }
    };

    return (
        <div className="w-100">
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <div className="row w-100">
                                <div className="col">
                                    <h4 className="card-header-title">앱 통계</h4>
                                </div>
                                <div className="col text-right" style={{ paddingRight: "0px" }}>
                                    <button type="button" className="btn btn-sm btn-link" onClick={() => onSelectStat("app")}>
                                        <span className="mr-1">더보기</span>
                                        <i className="fas fa-arrow-right" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body" style={{ height: "270px" }}>
                            <CommonHorizontalBarChart chartData={statApp} chartOption={appConnectChartOption} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <div className="row w-100">
                                <div className="col">
                                    <h4 className="card-header-title">지사별 사용량</h4>
                                </div>
                                <div className="col text-right" style={{ paddingRight: "0px" }}>
                                    <button type="button" className="btn btn-sm btn-link" onClick={() => onSelectStat("branch")}>
                                        <span className="mr-1">더보기</span>
                                        <i className="fas fa-arrow-right" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body" style={{ height: "270px" }}>
                            <CommonVerticalBarChart chartData={statBranch} chartOption={branchChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <div className="row w-100">
                                <div className="col">
                                    <h4 className="card-header-title">원별 사용량</h4>
                                </div>
                                <div className="col text-right" style={{ paddingRight: "0px" }}>
                                    <button type="button" className="btn btn-sm btn-link" onClick={() => onSelectStat("nursery")}>
                                        <span className="mr-1">더보기</span>
                                        <i className="fas fa-arrow-right" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body" style={{ height: "270px" }}>
                            <CommonVerticalBarChart chartData={statNursery} chartOption={nurseryChartOption} />
                        </div>
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <div className="row w-100">
                                <div className="col">
                                    <h4 className="card-header-title">콘텐츠별 사용량</h4>
                                </div>
                                <div className="col text-right" style={{ paddingRight: "0px" }}>
                                    <button type="button" className="btn btn-sm btn-link" onClick={() => onSelectStat("activity")}>
                                        <span className="mr-1">더보기</span>
                                        <i className="fas fa-arrow-right" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body" style={{ height: "270px" }}>
                            <MainContent data={statContent} libCategories={libCategories} height="270px" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeMain;
